/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import {
    arrayOf, bool, object, number, shape, string, func,
} from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import IconClose from '@material-ui/icons/Close';
import IconSearch from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';

import AddressBookForm from './AddressBookForm';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

import { useModalContext } from '../ModalContext/modal-context';

import { addressBookComponentList } from './Helper';
import { getAddressOneLineString, recipientBuilder } from '../Helpers/Input-Helper';
import { getHasMultiBrandProduct, getNoOfOrderItems } from '../../../../../../../state/ducks/MfeCheckout/ducks/Cart/Cart-Selectors';
import { getOrderItemErrors } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Selector';
import { clearOrderItemErrors } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Actions';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { loadAddressBookEntry, removeAddressBookEntry } from '../../../../../../../state/ducks/MfeCheckout/ducks/Member/AddressBookEntry/AddressBookEntry-Actions';
import {
    getRegisterAddressBookList, getRegisterAddressBookPageNumber,
    getRegisterAddressBookPages, getTotalRegisterAddressBook,
} from '../../../../../../../state/ducks/MfeCheckout/ducks/Member/AddressBookEntry/AddressBookEntry-Selector';
import { getFeatureFlags, getRelationshipListById } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import ComponentLoader from '../ComponentLoader/ComponentLoader';
import { updateChatgptGiftMessage } from '../../../../../../../state/ducks/MfeCheckout/ducks/CartItem/ChatGptMessage/ChatGptMessage-Actions';

const styles = (theme) => ({
    modalBox: {
        alignContent: 'flex-start',
        alignItems: 'flex-start',
        border: `1px solid ${theme.palette.common?.grey || '#666'}`,
        borderRadius: 5,
        background: theme.palette.common?.white || 'white',
        width: '100%',
        maxWidth: 800,
        '&:focus': {
            outline: 'none',
        },
        [theme.breakpoints.down('md')]: {
            margin: '20px',
            maxHeight: 'calc(100% - 40px)',
        },
    },
    header: {
        background: '#F4F4F4',
        color: theme.palette.primary?.main,
        padding: '0',
        '& h4': {
            fontSize: '1em',
            lineHeight: '1.2em',
            margin: 0,
            padding: '10px 5px',
            textAlign: 'center',
        },
    },
    icon: {
        color: '#000',
        fontSize: '24px',
        margin: '5px 10px',
    },
    searchTextBox: {
        padding: '3px 10px',
        width: 'calc(100% - 50px)',
        margin: '8px 25px',
        border: '1px solid #C4C4C4',
        backgroundColor: '#f4f4f4',
        borderRadius: '24px',
        '& input': {
            padding: '5px 10px',
            fontSize: '16px',

        },
        '&>div:after, &>div:before': {
            border: '0 !important',
            content: '""',
        },
        [theme.breakpoints.down('md')]: {
            padding: '0 15px',
        },
    },
    iconSearch: {
        color: '#4E4E4E',
    },
    contFilters: {
        backgroundColor: theme.palette.common?.white,
    },
    pageCount: {
        padding: '15px 25px',
        fontWeight: '500',
        textAlign: 'right',
        fontSize: '1em',
        color: theme.palette.primary?.main,
        [theme.breakpoints.down('md')]: {
            padding: '10px',
        },
    },
    pageLink: {
        backgroundColor: theme.palette.common?.white,
        border: `1px solid ${theme.palette.common?.white}`,
        borderRadius: '24px',
        color: theme.palette.common?.black,
        cursor: 'pointer',
        display: 'inline',
        fontWeight: '500',
        fontSize: '1em',
        padding: '2px',
        lineHeight: '19px',
        margin: '0px 2px',
        minWidth: 'auto',
        width: '24px',
        textTransform: 'none',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.common?.white,
            border: `1px solid ${theme.palette.common?.white}`,
            color: theme.palette.common?.black,
        },
    },
    pageLinkSelected: {
        backgroundColor: theme.palette.black,
        border: `1px solid ${theme.palette.common?.white}`,
        borderRadius: '24px',
        color: theme.palette.common?.white,
        cursor: 'pointer',
        display: 'inline',
        fontWeight: '500',
        fontSize: '1em',
        lineHeight: '19px',
        margin: '0px 2px',
        minWidth: 'auto',
        padding: '2px',
        width: '24px',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.common?.black,
            border: `1px solid ${theme.palette.common?.white}`,
            color: theme.palette.common?.white,
        },
    },
    fixedHeader: {
        borderBottom: '1px solid #c4c4c4',
        margin: '0',
        padding: '0',
        position: 'fixed',
        maxWidth: '798px',
        borderRadius: 5,
        zIndex: '2',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            borderBottom: 'none',
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downSmall,
            margin: 0,
            position: 'relative',
            width: theme.palette.tiers?.container?.maxWidth?.downSmall,
        },

    },
    dialogContent: {
        margin: '87px 0 10px 10px',
        overflowY: 'auto',
        width: '780px',
        minWidth: '85%',
        maxHeight: 'calc(100vh - 160px)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downSmall,
            width: theme.palette.tiers?.container?.maxWidth?.downSmall,
            overflowY: 'visible',
            margin: '0px 0 10px',
            padding: '0 15px',
        },
    },
    btnAddAddress: {
        backgroundColor: theme.palette.common?.white,
        color: theme.palette.cms?.primary || theme.palette.primary?.main,
        fontSize: '1em',
        textAlign: 'center',
        display: 'block',
        textTransform: 'none',
        width: '100%',
        minHeight: '115px',
        margin: '10px 0',
        padding: '0',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.common?.white,
            color: theme.palette.cms?.primary || theme.palette.primary?.main,
        },
        [theme.breakpoints.down('md')]: {
            fontWeight: 700,
            margin: '0',
        },
    },
    newAddress: {
        border: '1px dashed #C4C4C4',
        margin: '10px 0 0',
        borderRadius: '4px',
        minHeight: '110px',
    },
    leftCont: {
        backgroundColor: '#B0B0B0',
        color: '#fff',
        fontSize: '24px',
        '& span': {
            display: 'block',
            marginTop: 'calc(100% - 32px)',
        },
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    textNewAddress: {
        display: 'block',
        fontSize: '1em',
        marginTop: '40px',
        textDecoration: 'underline',
    },
    listAddresses: {
        border: `1px solid ${theme.palette.primary?.main}`,
        margin: '10px 0',
        borderRadius: '4px',
        minHeight: '110px',
    },
    rightList: {
        backgroundColor: '#f4f4f4',
        borderRadius: '0 4px 4px 0',
        [theme.breakpoints.down('md')]: {
            borderRadius: '4px',
        },
    },
    leftList: {
        backgroundColor: theme.palette.primary?.main,
        color: '#fff',
        fontSize: '24px',
        textAlign: 'center',
        textTransform: 'uppercase',
        '& span': {
            display: 'block',
            marginTop: 'calc(100% - 24px)',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },

    },
    phoneInfo: {
        textWrap: 'nowrap',
    },
    extraTopSpace: {
        paddingTop: '30px',
    },
    withoutFilters: {
        margin: '55px 0 10px 10px',
        maxHeight: 'calc(100vh - 124px)',
        [theme.breakpoints.down('xs')]: {
            margin: '20px 0 10px 0',
        },
    },
    addressItemContent: {
        padding: '0',
        margin: '0 15px',
        [theme.breakpoints.down('md')]: {
            padding: '5px 0',
            margin: 0,
        },
    },
    infoText: {
        fontSize: '1em',
        fontWeight: 'normal',
        padding: '0',
        margin: '10px',
        height: '55px',
        color: '#000',
        [theme.breakpoints.down('md')]: {
            height: 'auto',
            minHeight: '40px',
        },
    },
    btnUseAddress: {
        fontSize: '1em',
        width: '170px',
        margin: '5px 0 10px 10px',
        color: theme.palette.buttonBackgroundColor,
        backgroundColor: theme.palette.white,
        border: `1px solid ${theme.palette.buttonBackgroundColor}`,
        fontWeight: 'normal',
        padding: '2px 10px',
        textTransform: 'none',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.white,
            border: `1px solid ${theme.palette.buttonBackgroundColorSecondary}`,
            color: theme.palette.buttonBackgroundColorSecondary,
        },
        [theme.breakpoints.down('md')]: {
            width: 'auto',
            margin: '0 0 0 10px',
        },
    },
    contEditRemove: {
        padding: '7px 0',
        fontSize: '1em',
    },
    contButtons: {
        [theme.breakpoints.down('md')]: {
            margin: '5px 0',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '0 5px 5px 0',
        },
    },
    btnEditDelete: {
        fontSize: '1em',
        lineHeight: '1em',
        width: 'auto',
        minWidth: '30px',
        margin: '0',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        backgroundColor: 'transparent',
        border: 0,
        fontWeight: 'normal',
        padding: '0px 10px',
        textTransform: 'none',
        textDecoration: 'underline',
        '&:hover, &:focus': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
            backgroundColor: 'transparent',
            textDecoration: 'underline',
        },
        [theme.breakpoints.down('md')]: {
            width: 'auto',
            margin: '0',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '0px 5px',
        },

    },
});

const AddressBookModal = ({
    addressBookEntries,
    addressBookIsOpen,
    addressBookPageOn,
    addressBookTotalPages,
    callClearOrderItemErrors,
    callLoadAddressBook,
    callRemoveAddressBook,
    callTrackEvent,
    classes,
    featureFlags,
    handleCloseAddressBook,
    itemCountriesProdDeliverable,
    orderItem,
    orderItemErrors,
    pageType,
    relationshipList,
    setChatGPTData,
    totalAddresses,
}) => {
    if (!classes || !addressBookIsOpen) { return null; }

    const { setItemRecipientData, parentType, setParentType } = useModalContext();

    const [loader, setLoader] = useState(false);
    const [addressBookCollection, setAddressBookCollection] = useState([]);
    const [addressBookSearchResult, setAddressBookSearchResult] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [contentFormType, setContentFormType] = useState('list');
    const [selectedAddressInfo, setSelectedAddressInfo] = useState({});

    const lineItemType = orderItem.itemInfo?.lineItemType || '';
    const productBrandId = orderItem.product?.brandCode;
    const errors = orderItemErrors?.[orderItem.cartItemId]?.recipient || {};

    useEffect(() => {
        setLoader(true);
        callLoadAddressBook(0, setLoader);

        if (parentType !== 'addressbook') {
            setParentType('addressbook');
        }

        if (totalAddresses) {
            callTrackEvent({
                eventCategory: 'Checkout',
                eventAction: 'Feature Impression',
                eventLabel: `Address Count | ${totalAddresses}`,
            });
        }
    }, []);

    useEffect(() => {
        setAddressBookCollection(addressBookEntries);
        setAddressBookSearchResult(addressBookEntries);

        if (contentFormType !== 'list') {
            setContentFormType('list');
        }
    }, [addressBookEntries]);

    useEffect(() => {
        if (errors.errorMessage) {
            setContentFormType('edit');
        }
    }, [errors.errorMessage]);

    const handleAddAddressBook = () => {
        setContentFormType('add');
        setSelectedAddressInfo({});

        callClearOrderItemErrors(
            orderItem.cartItemId,
            'recipient',
            {
                errType: 'clearAllFields',
                field: '',
            },
        );
    };

    const handleCancelAddressBookForm = () => {
        callClearOrderItemErrors(
            orderItem.cartItemId,
            'recipient',
            {
                errType: 'clearAllFields',
                field: '',
            },
        );

        setContentFormType('list');
        setSelectedAddressInfo({});
    };

    const handleEditAddressBook = (editAddress) => {
        setContentFormType('edit');
        setSelectedAddressInfo(editAddress);

        callClearOrderItemErrors(
            orderItem.cartItemId,
            'recipient',
            {
                errType: 'clearAllFields',
                field: '',
            },
        );
    };

    const handleRemoveAddressBook = (addressBookEntryId) => {
        if (addressBookEntryId) {
            callRemoveAddressBook(addressBookEntryId);
        }
    };

    const handleSearchTextChange = (event) => {
        const strSearchText = event.target.value;
        const addressBookSearch = addressBookCollection.filter((item) => (
            getAddressOneLineString(item.addresses[0], 'addressBookEntry').toLocaleLowerCase().includes(strSearchText.toLowerCase())
        ));

        setSearchText(event.target.value);
        setAddressBookSearchResult(addressBookSearch);
    };

    const handleUseThisAddress = (selectedAddressData = {}) => {
        const formattedRecipientData = recipientBuilder(selectedAddressData);

        if (featureFlags['is-chat-gpt-enabled']) {
            setChatGPTData(orderItem.cartItemId, { recipientName: selectedAddressData?.firstName, relation: selectedAddressData?.relationship });
        }

        callClearOrderItemErrors(
            orderItem.cartItemId,
            'recipient',
            {
                errType: 'clearAllFields',
                field: '',
            },
        );

        callTrackEvent({
            eventCategory: 'Checkout',
            eventAction: 'Feature Interaction',
            eventLabel: 'Use This Address',
        });

        setSelectedAddressInfo(selectedAddressData);
        setItemRecipientData(formattedRecipientData);
        handleCloseAddressBook();
    };

    const onHandleChangeAddress = () => {
        setContentFormType('list');
        setSelectedAddressInfo({});
    };

    const getContent = () => {
        if (loader && !['add', 'edit'].includes(contentFormType)) {
            return <ComponentLoader />;
        }

        if (contentFormType === 'list') {
            return addressBookComponentList(
                classes, addressBookSearchResult, addressBookPageOn, addressBookTotalPages,
                handleRemoveAddressBook, handleEditAddressBook, handleUseThisAddress,
                itemCountriesProdDeliverable, relationshipList, lineItemType, productBrandId,
            );
        }

        if (['add', 'edit'].includes(contentFormType)) {
            return (
                <Grid container className={classes.addAdressBlock}>
                    <AddressBookForm
                        bookAddressValues={selectedAddressInfo}
                        handleChangeAddressBook={onHandleChangeAddress}
                        handleCloseAddressBook={handleCloseAddressBook}
                        handleCancelAddressBookForm={handleCancelAddressBookForm}
                        itemCountriesProdDeliverable={itemCountriesProdDeliverable}
                        orderItem={orderItem}
                        pageType={pageType}
                        relationshipList={relationshipList}
                        savingType={contentFormType}
                    />
                </Grid>
            );
        }
        return null;
    };

    let headerTitle = 'My Contacts';
    if (contentFormType === 'add') {
        headerTitle = 'Add New Address';
    } else if (contentFormType === 'edit') {
        headerTitle = 'Edit Address';
    }

    return (
        <Dialog
            open={addressBookIsOpen}
            onClose={handleCloseAddressBook}
            classes={{
                paper: classes.modalBox,
            }}
        >
            <Grid container>
                <Grid item xs={12} md={12} lg={12}>
                    <Grid container className={classes.fixedHeader}>
                        <Grid container className={classes.header}>
                            <Grid item xs={2} md={1} lg={1} align="right"> </Grid>
                            <Grid item xs={8} md={10} lg={10} align="center">
                                <h4>{headerTitle}</h4>
                            </Grid>
                            <Grid item xs={2} md={1} lg={1} align="right">
                                <div
                                    id="addressbook-close-btn"
                                    data-testid="addressbook-close-btn"
                                    onClick={() => handleCloseAddressBook(false)}
                                    onKeyDown={() => { }}
                                    role="button"
                                    tabIndex={-1}
                                >
                                    <IconClose className={classes.icon} titleAccess="Close" />
                                </div>
                            </Grid>
                        </Grid>
                        {
                            contentFormType === 'list'
                            && (
                                <>
                                    <Grid container className={classes.contFilters}>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                                id="addressBookSearchText"
                                                data-testid="addressBookSearchText"
                                                value={searchText}
                                                className={classes.searchTextBox}
                                                onChange={handleSearchTextChange}
                                                placeholder="Search for a address..."
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IconSearch className={classes.iconSearch} />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            &nbsp;
                                        </Grid>
                                    </Grid>
                                    {
                                        errors.errorMessage
                                        && (
                                            <Grid item xs={12} md={12} lg={12}>
                                                <ErrorMessage
                                                    noShadow
                                                    error={errors.errorMessage}
                                                />
                                            </Grid>
                                        )
                                    }
                                </>
                            )
                        }
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <Grid container className={`${classes.dialogContent} ${errors.errorMessage ? classes.extraTopSpace : ''} ${contentFormType !== 'list' ? classes.withoutFilters : null}`}>
                        {
                            !loader
                            && contentFormType === 'list'
                            && (
                                <Grid container className={classes.addressItemContent}>
                                    <Button
                                        id="add-new-address-book"
                                        data-test="add-new-address-book"
                                        data-testid="add-new-address-book"
                                        classes={{
                                            root: classes.btnAddAddress,
                                        }}
                                        onClick={handleAddAddressBook}
                                        disableRipple
                                    >
                                        <Grid container className={classes.newAddress} alignItems="stretch">
                                            <Grid className={classes.leftCont} item xs={12} md={1} lg={1}>
                                                <span>+</span>
                                            </Grid>
                                            <Grid item xs={12} md={11} lg={11}>
                                                <span className={classes.textNewAddress}>Add a new address</span>
                                            </Grid>
                                        </Grid>
                                    </Button>
                                </Grid>
                            )
                        }
                        {getContent()}
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
};

AddressBookModal.propTypes = {
    addressBookEntries: arrayOf(
        shape({
            firstName: string,
            lastName: string,
        }),
    ).isRequired,
    addressBookPageOn: number.isRequired,
    addressBookTotalPages: number.isRequired,
    addressBookIsOpen: bool.isRequired,
    callClearOrderItemErrors: func.isRequired,
    callLoadAddressBook: func.isRequired,
    callRemoveAddressBook: func.isRequired,
    callTrackEvent: func.isRequired,
    classes: object,
    featureFlags: object.isRequired,
    handleCloseAddressBook: func.isRequired,
    itemCountriesProdDeliverable: arrayOf(string).isRequired,
    orderItem: shape({
        cartItemId: string,
    }).isRequired,
    orderItemErrors: object.isRequired,
    pageType: string.isRequired,
    relationshipList: object,
    setChatGPTData: func.isRequired,
    totalAddresses: number.isRequired,
};

AddressBookModal.defaultProps = {
    classes: {},
    relationshipList: {},
};
const mapStateToProps = (state) => ({
    addressBookEntries: getRegisterAddressBookList(state),
    addressBookTotalPages: getRegisterAddressBookPages(state),
    addressBookPageOn: getRegisterAddressBookPageNumber(state),
    featureFlags: getFeatureFlags(state),
    hasMultiBrandProduct: getHasMultiBrandProduct(state),
    orderItemErrors: getOrderItemErrors(state),
    relationshipList: getRelationshipListById(state),
    totalAddresses: getTotalRegisterAddressBook(state),
    totalOrderItems: getNoOfOrderItems(state),
});

const mapDispatchToProps = (dispatch) => ({
    callClearOrderItemErrors: bindActionCreators(clearOrderItemErrors, dispatch),
    callLoadAddressBook: bindActionCreators(loadAddressBookEntry, dispatch),
    callRemoveAddressBook: bindActionCreators(removeAddressBookEntry, dispatch),
    callTrackEvent: bindActionCreators(trackEvent, dispatch),
    setChatGPTData: bindActionCreators(updateChatgptGiftMessage, dispatch),
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
)(AddressBookModal);
